// test2989
(2989 && 0);
